import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from 'antd/lib/avatar';
import 'antd/lib/avatar/style/index.css';
import Menu from 'antd/lib/menu';
import 'antd/lib/menu/style/index.css';
var ItemGroup = Menu.ItemGroup, Item = Menu.Item;
import MenuItemGroupBottom from './MenuItemGroupBottom';
var selfStyles = require('./styles.scss');
var MenuListEventsList = function (props) {
    return (React.createElement(Menu, { mode: 'inline', className: selfStyles.menu },
        React.createElement(ItemGroup, { title: React.createElement("span", { className: selfStyles.menuHeader }, "Your Events") }, props.events
            .sort(function (a, b) { return b.dateStart.localeCompare(a.dateStart); })
            .map(function (e) { return (React.createElement(Item, { key: "/event/" + e.subdomain, className: selfStyles.menuItem },
            React.createElement(Link, { to: "/event/" + e.subdomain, className: selfStyles.menuOption },
                React.createElement(Avatar, { shape: 'square', size: 'small', src: e.logoUrl || e.logoIdenticon, className: selfStyles.menuOptionAvatar }),
                React.createElement("span", { className: selfStyles.menuItemText }, e.nameShort)))); })),
        React.createElement(MenuItemGroupBottom, null)));
};
var MenuListEventsEmpty = function () { return (React.createElement(Menu, { mode: 'inline', className: selfStyles.menu },
    React.createElement(Item, { disabled: true, className: selfStyles.menuItemMultiline },
        React.createElement("p", null, "You are not involved in any events on CRIMP.")),
    React.createElement(MenuItemGroupBottom, null))); };
var MenuListEvents = function (props) {
    return props.events.length === 0
        ? React.createElement(MenuListEventsEmpty, null)
        : React.createElement(MenuListEventsList, { events: props.events });
};
export default MenuListEvents;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageMenu/MenuListEvents.tsx
// module id = 804
// module chunks = 0